//
// SelectionControlItem.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import EventDispatcher from "../events/EventDispatcher";
import "../lib";
import "../models/BaseUIModel";
import "./SelectionControlTerm";
import "./Selection";
import "./SelectionController";
import "./SelectionOptions";

var SelectionControlItem = createModule("commons::SelectionControlItem", ["commons::PropertyOwner","commons::BaseModel","commons::BaseUIModel"], EventDispatcher, [
    ,
    {
        selections: [1],
        terms: [1],
        selectionOptions: 1,
        selectionController: 1,
        readOnly: 2,
        label: 7,
    },
    ,
    ,
    {
        removeTerm: [2,1],
    },
    {
        _create: [4],
    },
    ,
]);
export default SelectionControlItem;
